<template>
    <label
        :class="
            'class' in $attrs ? $attrs.class : 'input-label whitespace-nowrap'
        "
    >
        <slot />
    </label>
</template>
